<template>
  <div class="movie">
    <el-button type="primary" size="small" icon="el-icon-plus" @click="create">创建</el-button>

    <el-input v-model="key" size="small" style="margin-left: 20px; width: 200px;" placeholder="搜索"></el-input>

    <el-table :data="list" style="width: 100%" class="table">
      <el-table-column label="封面" width="120">
        <template slot-scope="scope">
          <img class="thumb" :src="scope.row.thumb">
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" width="400">
        <template slot-scope="scope">
          <div>{{scope.row.title}}</div>
          <div>{{scope.row.title_en}}</div>
        </template>
      </el-table-column>
      <el-table-column label="所属机构" width="180">
        <template slot-scope="scope">
          {{scope.row.partner && scope.row.partner.title}}
        </template>
      </el-table-column>
      <el-table-column label="显示/隐藏" width="100">
        <template slot-scope="scope">
          <el-switch
            :active-value="0"
            :inactive-value="1"
            v-model="scope.row.is_hidden"
            @change="change($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="time" label="时间" width="160"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showAppPath(scope.row)" v-if="type==='information'||type==='movie_track'||type==='discussion'">路径</el-button>
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[5, 10, 15, 20]" :page-size="per_page" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog :title="action===0?'创建':'编辑'" :visible.sync="dialogVisible" width="1200px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="标题" style="width: 800px"></el-input>
        </el-form-item>
        <el-form-item label="标题(英文)" prop="title">
          <el-input v-model="form.title_en" placeholder="标题(英文)" style="width: 800px"></el-input>
        </el-form-item>
        <el-form-item label="时间" prop="time">
          <el-date-picker type="datetime" placeholder="选择日期时间" v-model="form.time" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>

        <el-form-item label="所属机构" prop="title">
          <el-select v-model="form.partner_id" placeholder="请选择" style="width:300px">
             <el-option :value="partner.id" :label="partner.title" v-for="partner in partnerList">{{partner.title}}</el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="封面" prop="thumb">
          <img v-if="form.thumb" class="thumb cursor-pointer" :src="form.thumb" title="点击更换" @click="selectThumb">
          <div v-else class="addimg" @click="selectThumb">+</div>
        </el-form-item>
        <el-form-item label="详情">

          <el-button-group style="margin-bottom: 20px;">
            <el-button size="small" value="cn"  :type="pageLang == 'cn' ? 'primary' : ''"  @click="changePageLang('cn')" :autofocus="true">中文版</el-button>
            <el-button size="small" value="en" :type="pageLang == 'en' ? 'primary' : ''" @click="changePageLang('en')">英文版</el-button>
          </el-button-group>

          <edit-box></edit-box>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="action===0" type="primary" @click="submit">确 定</el-button>
        <el-button v-show="action===1" type="primary" @click="saveChange">保存更改</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" title="路径" center width="800px">
      <el-form label-width="80px">
        <el-form-item label="小程序">
          <el-input :value="miniAppPath">
          </el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>
  </div>
</template>
<script>
import request from '@/utils/request'
import editBox from '../../pages/components/editBox'
import UploadImg from '@/components/UploadImg'
export default {
  components: {
    editBox,
    UploadImg
  },
  props: {
    type: {
      type: String,
      default: 'information'
    }
  },
  data () {
    var validateThumb = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择封面'))
      } else {
        callback()
      }
    }
    return {
      pageLang: 'cn',
      action: 0,
      list: [],
      dialogVisible: false,
      dialogVisible2: false,
      miniAppPath: '',
      page: 1,
      per_page: 10,
      total: 0,
      current: {},
      partnerList: [],
      pageLang: 'cn',
      form: {
        title: '',
        title_en: '',
        time: '',
        thumb: '',
        page: {
          style: {
            padding: 0
          },
          modules: []
        },
        page_en: {
          style: {
            padding: 0
          },
          modules: []
        }
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        thumb: [
          { validator: validateThumb, trigger: 'blur' }
        ],
        time: [
          { required: true, message: '请选择日期时间', trigger: 'change' }
        ]
      },
      key: ''
    }
  },
  watch: {
    key () {
      this.page = 1
      this.getList()
    }
  },
  created () {
    this.getList()
    this.getPartnerList()
  },
  methods: {
    changePageLang (lang)  {
      if (lang == 'cn') {
        this.$store.commit('SET_PAGE', this.form.page)
        this.$store.commit('SET_PAGE_CURRENTITEM', '')
      }
      else if (lang == 'en') {
        this.$store.commit('SET_PAGE', this.form.page_en)
        this.$store.commit('SET_PAGE_CURRENTITEM', '')
      }
      this.pageLang = lang
    },
    showAppPath (row) {
      this.miniAppPath = 'pages/newsDetail/index?type=' + this.type + '&uuid=' + row.uuid
      this.dialogVisible2 = true
    },
    getList () {
      request({
        url: '/movie/articles',
        params: {
          per_page: this.per_page,
          page: this.page,
          type: this.type,
          key: this.key
        }
      }).then(res => {
        this.list = res.data.list
        this.total = res.data.item_total
      })
    },
    getPartnerList () {
      request({
        url: '/partners',
      }).then(res => {
        this.partnerList = res.data.list
        this.partnerList.unshift({
          'id': null,
          'title': '不绑定机构'
        })
      })
    },
    handleSizeChange (e) {
      this.per_page = e
      this.handleCurrentChange(1)
    },
    handleCurrentChange (e) {
      this.page = e
      this.getList()
    },
    create () {
      this.action = 0
      this.dialogVisible = true
      this.form = {
        title: '',
        title_en: '',
        time: '',
        thumb: '',
        partner_id: '',
        page: {
          style: {
            padding: 0
          },
          modules: []
        },
        page_en: {
          style: {
            padding: 0
          },
          modules: []
        },
      }
      this.$store.commit('SET_PAGE', this.form.page)
      this.$store.commit('SET_PAGE_CURRENTITEM', '')
    },
    editItem (row) {
      this.current = row
      this.action = 1
      this.dialogVisible = true
      this.form = {
        title: row.title,
        title_en: row.title_en,
        time: row.time,
        thumb: row.thumb,
        partner_id: row.partner_id,
        page: row.page,
        page_en: row.page_en || {
          style: {
            padding: 0
          },
          modules: []
        }
      }
      this.$store.commit('SET_PAGE', this.form.page)
      this.$store.commit('SET_PAGE_CURRENTITEM', '')
      this.pageLang = 'cn'
      console.log(row)
    },
    selectThumb () {
      let list = []
      if (this.form.thumb) {
        list = [this.form.thumb]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form.thumb = res[0]
        }
      }).catch(_ => {})
    },
    submit () {
      this.form.type = this.type
      request({
        url: '/movie/articles',
        method: 'post',
        data: this.form
      }).then(res => {
        this.$message.success('创建成功!')
        this.dialogVisible = false
        this.handleCurrentChange(1)
        this.resetForm()
      })
    },
    saveChange () {
      request({
        url: '/movie/articles/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: this.form
        }
      }).then(res => {
        this.$message.success('保存成功!')
        this.dialogVisible = false
        this.getList()
        this.resetForm()
      })
    },
    resetForm () {
      this.form = {
        title: '',
        title_en: '',
        time: '',
        thumb: '',
        partner_id: '',
        page: {
          style: {
            padding: 0
          },
          modules: []
        },
        page_en: {
          style: {
            padding: 0
          },
          modules: []
        }
      }
      this.$refs['form'].resetFields()
    },
    deleteItem (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/movie/articles/' + row.uuid,
          method: 'delete'
        }).then(res => {
          this.$message.success('删除成功!')
          this.getList()
        })
      }).catch()
    },
    change (e, row) {
      request({
        url: '/movie/articles/' + row.uuid,
        method: 'patch',
        data: {
          type: e ? 'hide' : 'show'
        }
      }).then(() => {}).catch(() => {
        this.getList()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.table {
  border: 1px solid #ebeef5;
  border-bottom: none;
  margin-top: 10px;
}
.pager {
  margin: 15px 0;
}
.addimg {
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #666;
  font-size: 17px;
  border: 1px dashed #999999;
  cursor: pointer;
}
.thumb {
  height: 50px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/movie/components/articles.vue